<template>
  <nav
    class="navbar navbar-primary is-fixed-top"
    role="navigation"
    aria-label="main navigation"
  >
    <div id="site-header" class="container">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <img src="/logo.png" />
        </a>

        <span id="navbar-brand-tagline">
          <span class="better">Better.</span>
          <span class="together">Together.</span>
        </span>

        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarMain"
          @click="toggleActive()"
          v-bind:class="{ 'is-active': is_active }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div
        id="navbarMain"
        class="navbar-menu"
        :class="{
          'navbar-secondary-active': $route.meta.secondary,
          'is-active': is_active,
        }"
      >
        <div class="navbar-end desktop">
          <router-link
            class="navbar-item"
            v-for="navItem in navItems_desktop"
            :key="navItem.id"
            :to="{ path: '/', hash: `#${navItem.id}` }"
            >{{ navItem.title }}</router-link
          >
          <router-link class="navbar-item" to="/contact">Contact</router-link>
        </div>
        <div class="navbar-end mobile">
          <router-link
            class="navbar-item"
            v-for="navItem in navItems_mobile"
            :key="navItem.id"
            :to="{ path: '/', hash: `#${navItem.id}` }"
            >{{ navItem.title }}</router-link
          >
          <router-link class="navbar-item" to="/contact">Contact</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "SiteHeader",
  props: {
    secondary_active: Boolean,
  },
  data: function () {
    return {
      is_active: false,
      navItems_desktop: [
        { id: "home", title: "Home" },
        { id: "our-model", title: "Our Model" },
        { id: "our-network", title: "Our Network" },
        { id: "our-platform", title: "Our Platform" },
      ],
      navItems_mobile: [{ id: "home", title: "Home" }],
    };
  },
  computed: {
    baseURL: () => window.location.origin,
  },
  methods: {
    toggleActive: function () {
      this.is_active = !this.is_active;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 425px) {
  .desktop {
    display: none;
  }
}
@media screen and (min-width: 426px) {
  .mobile {
    display: none;
  }
}
</style>
